import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getFuelSupplyTypeList,
	addNewFuelSupplyType,
	updateFuelSupplyType,
	deleteFuelSupplyType,
	getFuelSupplyType,
	getFuelSupplyTypeCode,
} from '../fuelSupplyType/thunk';

export const initialState = {
	itemFuelSupplyTypeList: [],
	itemFuelSupplyTypeDetail: null,
	isFuelSupplyTypeLoading: false,
	isFuelSupplyTypeSuccess: false,


	fuelSupplyTypeList: [],
	fuelSupplyTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const FuelSupplyTypeSlice = createSlice({
	name: 'FuelSupplyType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFuelSupplyType.fulfilled, (state, action) => {
			state.isFuelSupplyTypeLoading = false;
			state.isFuelSupplyTypeSuccess = true;
			state.itemFuelSupplyTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFuelSupplyType.pending, state => {
			state.isFuelSupplyTypeLoading = true;
			state.isFuelSupplyTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelSupplyType.rejected, (state, action) => {
			state.isFuelSupplyTypeLoading = false;
			state.isFuelSupplyTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});


		
		builder.addCase(getFuelSupplyTypeCode.fulfilled, (state, action) => {
			state.isFuelSupplyTypeLoading = false;
			state.isFuelSupplyTypeSuccess = true;
			state.itemFuelSupplyTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFuelSupplyTypeCode.pending, state => {
			state.isFuelSupplyTypeLoading = true;
			state.isFuelSupplyTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelSupplyTypeCode.rejected, (state, action) => {
			state.isFuelSupplyTypeLoading = false;
			state.isFuelSupplyTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getFuelSupplyTypeList.pending, state => {
			state.isFuelSupplyTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFuelSupplyTypeList.fulfilled, (state, action) => {
			state.itemFuelSupplyTypeList = action.payload;
			state.fuelSupplyTypeList = action.payload;
			state.isLoadingList = false;
			state.isFuelSupplyTypeSuccess = true;

			let fuelSupplyTypeListSelect = [];
			action.payload.map(item =>
				fuelSupplyTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.fuelSupplyTypeListSelect = fuelSupplyTypeListSelect;
		});
		builder.addCase(getFuelSupplyTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFuelSupplyTypeSuccess = true;
		});
		builder.addCase(addNewFuelSupplyType.fulfilled, (state, action) => {
			state.itemFuelSupplyTypeList.push(action.payload);
			state.fuelSupplyTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFuelSupplyType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFuelSupplyType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFuelSupplyType.fulfilled, (state, action) => {
			state.itemFuelSupplyTypeList = state.itemFuelSupplyTypeList.map(fuelSupplyType =>
				fuelSupplyType.fuelSupplyTypename === action.payload.old_fuelSupplyType
					? { ...fuelSupplyType, ...action.payload.updated_fuelSupplyType }
					: fuelSupplyType
			);
			state.fuelSupplyTypeList = state.fuelSupplyTypeList.map(fuelSupplyType =>
				fuelSupplyType._id.toString() === action.payload._id.toString()
					? { ...fuelSupplyType, ...action.payload }
					: fuelSupplyType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFuelSupplyType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFuelSupplyType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFuelSupplyType.fulfilled, (state, action) => {
			state.itemFuelSupplyTypeList = current(state.itemFuelSupplyTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.fuelSupplyTypeList = current(state.fuelSupplyTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFuelSupplyType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFuelSupplyType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = FuelSupplyTypeSlice.actions;

export default FuelSupplyTypeSlice.reducer;
